
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Licitacion {
  id: number;
  created_at: string;
  idEvl: string;
  url: string | null;
  expediente: string | null;
  objeto_contrato: string | null;
  estado: string | null;
  importe: number | null;
  fecha_fin_presentacion: string | null;
  forma_presentacion: string | null;
  procedimiento: string | null;
  fecha_publicacion: string | null;
  financiacion_UE: string | null;
  organo_contratacion: string | null;
  tipo_contrato: string | null;
  sistema_contratacion: string | null;
  lugar_ejecucion: string | null;
  codigo_cpv: Array<{
    codigo: string;
    concepto: string;
  }> | null;
}
